Ext.define('SA.model.Sort', {
    statics: {
        create(params) {
            return new SA.model.Sort(params);
        },

        from(item, direction) {
            if (direction === undefined && Array.isArray(item)) {
                return this.fromArray(item);
            }

            return this.create({item, direction});
        },

        fromArray([direction, item]) {
            return this.create({direction, item});
        }
    },

    constructor({direction = 'desc', item}) {
        this.direction = direction;
        this.item = item;
    },

    equal(otherSort) {
        return SA.Json.equal(this.toArray(), SA.model.Sort.from(otherSort).toArray());
    },

    toArray() {
        return [this.direction, this.item];
    }
});